const en = {
  // Common
  back: 'Back',
  save: 'Save',
  cancel: 'Cancel',
  delete: 'Delete',
  close: 'Close',
  loading: 'Loading...',
  saving: 'Saving...',
  saved: 'Saved!',
  search: 'Search',
  edit: 'Edit',
  confirm: 'Confirm',
  yes: 'Yes',
  no: 'No',
  or: 'or',
  and: 'and',
  none: 'None',
  unknown: 'Unknown',
  optional: 'optional',
  required: 'Required',
  noResults: 'No results found',
  signOut: 'Sign Out',

  // Dashboard
  dashboard: 'Dashboard',
  yourFamilyCircles: 'Your Family Circles',
  selectCircleDesc: 'Select a family circle to record and listen to stories',
  loadingCircles: 'Loading your circles...',
  members: 'members',
  createNewCircle: 'Create New Circle',
  startPreserving: 'Start preserving memories with your family',
  createFamilyCircle: 'Create Family Circle',
  circleName: 'Circle Name',
  circleNamePlaceholder: 'The Smith Family',
  descriptionOptional: 'Description (optional)',
  descriptionPlaceholder: 'Our family memories and stories',
  creating: 'Creating...',
  createCircle: 'Create Circle',
  noDescription: 'No description',
  hello: 'Hello',
  help: 'Help',
  settings: 'Settings',

  // Settings
  settingsTitle: 'Settings',
  profile: 'Profile',
  displayName: 'Display Name',
  birthday: 'Birthday',
  birthplace: 'Birthplace',
  birthplacePlaceholder: 'e.g., Oakland, CA',
  bio: 'Bio',
  bioPlaceholder: 'A short note about yourself...',
  profileSyncNote: 'Birthday, birthplace, and bio will automatically sync to your family tree entries.',
  saveProfile: 'Save Profile',
  profileSaved: 'Profile Saved!',
  changePhoto: 'Change photo',

  // Language
  language: 'Language',
  languageNote: 'Language will be applied to the app interface.',
  saveLanguage: 'Save Language',

  // Security
  security: 'Security',
  changePassword: 'Change Password',
  changePasswordDesc: 'Update your account password',
  currentPassword: 'Current Password',
  currentPasswordPlaceholder: 'Enter current password',
  newPassword: 'New Password',
  newPasswordPlaceholder: 'At least 8 characters',
  confirmNewPassword: 'Confirm New Password',
  confirmNewPasswordPlaceholder: 'Re-enter new password',
  changingPassword: 'Changing...',
  passwordChanged: 'Password changed successfully!',
  passwordsDoNotMatch: 'Passwords do not match',
  passwordRuleLength: 'At least 8 characters',
  passwordRuleUppercase: 'One uppercase letter',
  passwordRuleNumber: 'One number',
  passwordRuleSpecial: 'One special character',

  // Notifications
  emailNotifications: 'Email Notifications',
  enableNotifications: 'Enable email notifications',
  enableNotificationsDesc: 'Receive emails about activity in your family circles',
  deliveryMethod: 'Delivery method',
  instant: 'Instant',
  dailyDigest: 'Daily Digest',
  both: 'Both',
  notificationTypes: 'Notification types',
  newStoryAdded: 'New story added',
  newStoryAddedDesc: 'When someone records a new story in your family circle',
  commentsOnStories: 'Comments on your stories',
  commentsOnStoriesDesc: 'When someone comments on a story you recorded',
  reactionsToComments: 'Reactions to your comments',
  reactionsToCommentsDesc: 'When someone reacts to a comment you posted',
  newMemberJoined: 'New member joined',
  newMemberJoinedDesc: 'When someone new joins your family circle',
  inviteAccepted: 'Invite accepted',
  inviteAcceptedDesc: 'When someone you invited accepts and joins',
  saveChanges: 'Save Changes',

  // Danger Zone
  dangerZone: 'Danger Zone',
  deleteAccount: 'Delete Account',
  deleteAccountDesc: 'Permanently delete your account and all associated data',
  deleteAccountWarning: 'This action is permanent and irreversible. All your data, stories, and family circle memberships will be removed.',
  enterPassword: 'Enter your password',
  typeDelete: 'Type DELETE to confirm',
  deletingAccount: 'Deleting...',
  deleteMyAccount: 'Delete My Account',

  // Email confirmation
  emailNotConfirmed: 'Your email is not yet confirmed.',
  resend: 'Resend',
  sending: 'Sending...',
  sent: 'Sent!',

  // Family Circle
  stories: 'Stories',
  membersTab: 'Members',
  tree: 'Tree',
  recordStory: 'Record a Story',
  exportMemoryBook: 'Export Memory Book',
  story: 'story',
  storiesFound: 'found',
  noStoriesMatch: 'No stories match your search',
  clearFilters: 'Clear filters',
  noStoriesYet: 'No stories yet',
  beFirstToRecord: 'Be the first to record a family story!',
  filterByStoryteller: 'Filter by Storyteller',
  allMembers: 'All members',
  searchStories: 'Search stories...',

  // Story Detail
  originalRecording: 'Original Recording',
  aiVoiceNarration: 'AI Voice Narration (polished)',
  loadAudio: 'Load Audio',
  loadingAudio: 'Loading...',
  generateVoice: 'Generate Voice Narration',
  cloneVoice: 'Clone Voice from This Recording',
  linkedStories: 'Linked Stories',
  linkStory: '+ Link Story',
  linkAStory: 'Link a Story',
  connectStoryDesc: 'Connect this story to another related story in your family circle.',
  searchByTitle: 'Search by title...',
  relationship: 'Relationship',
  noteOptional: 'Note (optional)',
  related: 'Related',
  continuation: 'Continuation',
  sameEvent: 'Same Event',
  mentionedIn: 'Mentioned In',
  responseTo: 'Response To',
  parentStory: 'Parent Story',
  childStory: 'Child Story',
  noLinkedStories: 'No linked stories yet',
  category: 'Category',
  uncategorized: 'Uncategorized',
  tags: 'Tags',
  noTagsYet: 'No tags yet — click to add',
  addTag: 'Add',
  saveTags: 'Save Tags',
  comments: 'Comments',
  addComment: 'Add a comment...',
  postComment: 'Post',
  noComments: 'No comments yet. Be the first to share your thoughts!',
  deleteStory: 'Delete Story',
  deleteStoryConfirm: 'Are you sure you want to delete this story? This will permanently remove the story, all photos, and audio recordings. This action cannot be undone.',
  deletingStory: 'Deleting...',

  // Export Modal
  exportMemoryBookTitle: 'Export Memory Book',
  exportDescription: 'Generate a beautifully formatted PDF of your family\'s stories.',
  storyVersion: 'Story Version',
  literary: 'Literary (full narrative)',
  polished: 'Polished (restructured)',
  original: 'Original (transcript)',
  includePhotos: 'Include photos',
  groupByCategory: 'Group stories by category (chapter dividers)',
  generatePDF: 'Generate PDF',
  allStorytellers: 'All storytellers',
  allCategories: 'All categories',
  filterByCategory: 'Filter by Category',

  // Family Tree
  familyTree: 'Family Tree',
  visualizeRelationships: 'Visualize your family relationships',
  exportTreePDF: 'Export Tree PDF',
  noTreeMembers: 'No family members to display yet.',
  addMembersFirst: 'Add members in the Members tab first.',
  clickToEdit: 'Click to edit',
  editFamilyMember: 'Edit Family Member',
  updateInfoFor: 'Update info for',
  relationshipLabel: 'Relationship Label',
  generation: 'Generation',
  parent: 'Parent',
  spouse: 'Spouse',
  birthDate: 'Birth Date',
  birthPlace: 'Birth Place',
  deathDate: 'Death Date',
  deathPlace: 'Death Place',
  markDeceased: 'Mark as deceased',
  bioOptional: 'Bio (optional)',
  bioPlaceholderTree: 'A brief note about this person...',
  saveTreeChanges: 'Save Changes',

  // Categories
  catEarlyLife: 'Early Life',
  catChildhood: 'Childhood',
  catSchool: 'School',
  catCollege: 'College',
  catCareer: 'Career',
  catMarriage: 'Marriage',
  catFamily: 'Family',
  catParenting: 'Parenting',
  catMilitary: 'Military',
  catTravel: 'Travel',
  catImmigration: 'Immigration',
  catTraditions: 'Traditions',
  catHolidays: 'Holidays',
  catFaith: 'Faith',
  catHealth: 'Health',
  catHobbies: 'Hobbies',
  catFriendship: 'Friendship',
  catLoss: 'Loss',
  catAchievement: 'Achievement',
  catAdvice: 'Advice',
  catOther: 'Other',

  // Generations
  genGrandparents: 'Grandparents & Above',
  genParents: 'Parents',
  genYouSiblings: 'You & Siblings',
  genChildren: 'Children',
  genGrandchildren: 'Grandchildren',

  // Help
  helpCenter: 'Help Center',
  helpSubtitle: 'Everything you need to know about EchoMemoir',
  searchForHelp: 'Search for help...',
  quickStartGuides: 'Quick Start Guides',
  faq: 'Frequently Asked Questions',
  allTopics: 'All Topics',
  searchResults: 'Search Results',
  stillNeedHelp: 'Still Need Help?',
  cantFindAnswer: "Can't find what you're looking for? Reach out to our team.",
  emailSupport: 'Email Support',

  // FamilyCircle - Tabs
  prompts: 'Prompts',
  record: 'Record',

  // FamilyCircle - Stories
  startRecordingFirst: 'Start recording your first memory',
  storyteller: 'Storyteller',
  sortBy: 'Sort by',
  newestFirst: 'Newest first',
  oldestFirst: 'Oldest first',
  chooseCategoryPrompt: 'Choose a category to find inspiring questions',
  storyTitle: 'Story Title',
  storyTitlePlaceholder: 'My Childhood Memories...',
  recordingTip: 'Speak clearly and take your time. Share your story naturally.',

  // FamilyCircle - Members
  invite: 'Invite',
  owner: 'Owner',
  you: 'You',
  onlyVaultKeepers: 'Only Vault Keepers can manage members and send invites.',
  pendingInvites: 'Pending Invites',
  expires: 'Expires',
  cancelInvite: 'Cancel Invite',

  // FamilyCircle - Voice
  voiceProfiles: 'Voice Profiles',
  noVoiceProfilesYet: 'No voice profiles yet',
  createVoiceProfile: 'Create Voice Profile',
  voiceName: 'Voice Name',
  voiceNamePlaceholder: "e.g., Dad's Voice, Grandma Maria",
  audioSamples: 'Audio Samples',
  creatingVoice: 'Creating...',
  createVoice: 'Create Voice',

  // FamilyCircle - Tree
  visualizeRelationships: 'Visualize your family relationships',
  noTreeMembers: 'No family members to display yet.',
  addMembersFirst: 'Add members in the Members tab first.',

  // Invite Modal
  inviteSent: 'Invite Sent!',
  inviteSentDesc: 'An invitation has been sent to',
  inviteJoinLink: "They'll receive an email with a link to join",
  done: 'Done',
  inviteFamilyMember: 'Invite Family Member',
  sendInviteDesc: "Send an invitation to join",
  sendInviteDesc2: "They'll receive an email with a link to join.",
  emailAddress: 'Email Address',
  role: 'Role',
  contributorRole: 'Contributor - Can add stories',
  storytellerRole: 'Storyteller - Full access',
  viewerRole: 'Viewer - Can only view',
  relationshipOptional: 'Relationship (optional)',
  relationshipPlaceholder: 'e.g., Daughter, Uncle, Cousin',
  sendInvite: 'Send Invite',

  // Change Role Modal
  changeRole: 'Change Role',
  changeRoleDesc: 'Change the role for',
  newRole: 'New Role',
  vaultKeeperRole: '👑 Vault Keeper - Full control',
  storytellerRoleFull: '📖 Storyteller - Can manage stories',
  contributorRoleFull: '✍️ Contributor - Can add stories',
  viewerRoleFull: '👁️ Viewer - Can only view',
  updating: 'Updating...',
  updateRole: 'Update Role',

  // Remove Member Modal
  removeMember: 'Remove Member',
  removeMemberDesc: 'Are you sure you want to remove',
  removeMemberDesc2: 'from this family circle? They will lose access to all stories.',
  removing: 'Removing...',

  // Tree Edit Modal
  editFamilyRelationship: 'Edit Family Relationship',
  updateTreePosition: 'Update tree position for',
  relationshipLabel: 'Relationship Label',
  relationshipLabelPlaceholder: 'e.g., Father, Grandmother, Uncle',
  greatGrandparents: 'Great-Grandparents',
  grandparents: 'Grandparents',
  parents: 'Parents',
  youAndSiblings: 'You & Siblings',
  children: 'Children',
  grandchildren: 'Grandchildren',
  greatGrandchildren: 'Great-Grandchildren',

  // Export Modal
  storyVersionLabel: 'Story Version',
  allStorytellers: 'All storytellers',
  generating: 'Generating...',

  // Upgrade Modal
  upgradePlan: 'Upgrade Your Plan',
  upgradeUnlock: 'Upgrade to unlock:',
  maybeLater: 'Maybe Later',
  viewPlans: 'View Plans',
  upgradeNote: 'Plans start at $8/mo. Cancel anytime.',
  upgradeFeature1: 'Up to 50 or unlimited stories',
  upgradeFeature2: 'Multiple family circles',
  upgradeFeature3: 'Voice cloning',
  upgradeFeature4: 'PDF exports & memory books',

  // Pricing Page
  pricingBackToSettings: 'Back to Settings',
  pricingWelcome: 'Welcome to your new plan! Your subscription is now active.',
  pricingTitle: 'Choose Your Plan',
  pricingSubtitle: "Preserve your family's stories for generations to come",
  pricingMonthly: 'Monthly',
  pricingAnnual: 'Annual',
  pricingSave20: 'Save 20%',
  pricingMostPopular: 'Most Popular',
  pricingCurrentPlan: 'Current Plan',
  pricingMo: 'mo',
  pricingYear: 'year',
  pricingBilled: 'Billed',
  pricingManage: 'Manage Subscription',
  pricingDowngrade: 'Downgrade',
  pricingGetStarted: 'Get Started',
  pricingUpgrade: 'Upgrade',
  pricingRedirecting: 'Redirecting...',
  pricingCancelsAt: 'Cancels at end of period:',
  pricingYourUsage: 'Your Usage',
  pricingFamilyCircles: 'Family Circles',
  pricingQuestions: 'Questions?',
  pricingFaq1Q: 'Can I change plans later?',
  pricingFaq1A: 'Yes! Upgrade or downgrade anytime. Changes take effect on your next billing cycle.',
  pricingFaq2Q: 'What happens if I cancel?',
  pricingFaq2A: 'You keep access until the end of your billing period, then your account reverts to the Free plan. Your stories are never deleted.',
  pricingFaq3Q: 'Is there a free trial?',
  pricingFaq3A: "The Free plan is yours forever — no credit card required. Upgrade only when you're ready.",

  // Plan names & features
  planFree: 'Free',
  planFreeTagline: 'Start preserving memories',
  planFreeF1: '3 stories',
  planFreeF2: '1 family circle',
  planFreeF3: '5 members per circle',
  planFreeF4: 'AI story enhancement',
  planFreeF5: '100 MB storage',
  planFreeLim1: 'No voice cloning',
  planFreeLim2: 'No PDF exports',
  planKeeperTagline: 'For growing families',
  planKeeperF1: '50 stories',
  planKeeperF2: '3 family circles',
  planKeeperF3: '20 members per circle',
  planKeeperF4: 'AI story enhancement',
  planKeeperF5: 'Voice cloning',
  planKeeperF6: 'PDF exports & memory books',
  planKeeperF7: '5 GB storage',
  planVaultTagline: 'Unlimited family legacy',
  planVaultF1: 'Unlimited stories',
  planVaultF2: 'Unlimited family circles',
  planVaultF3: 'Unlimited members',
  planVaultF4: 'AI story enhancement',
  planVaultF5: 'Voice cloning',
  planVaultF6: 'PDF exports & memory books',
  planVaultF7: '50 GB storage',
  planVaultF8: 'Priority support',

  // Settings - Subscription
  settingsSubscription: 'Subscription',
  settingsFreePlan: 'Free Plan',
  settingsUpgradeDesc: 'Upgrade for more stories, voice cloning, and PDF exports',
  settingsAnnualBilling: 'Annual billing',
  settingsMonthlyBilling: 'Monthly billing',
  settingsManagePlan: 'Manage Plan',
};

export default en;